<template>
  <ModalControl @closed="closed" v-bind:show="display" v-bind:title="title">
    <div>
      <img
        src="@/assets/icons/papsi_info_green.svg"
        class="block mx-auto mt-2 h-modal-icon w-modal-icon"
      />

      <div
        v-text="message"
        class="text-sm text-center pt-5 pb-5"
      ></div>

      <div class="flex text-center text-sm font-bold">
        <ButtonControl
          :outline="true"
          :full_width="true"
          @click="cancel"
          class="w-1/2 mr-2"
        >
          {{ lang("cancel") }}
        </ButtonControl>

        <ButtonControl
          theme="success"
          :full_width="true"
          @click="ok"
          class="w-1/2"
        >
          {{ lang("yes") }}
        </ButtonControl>
      </div>
    </div>
  </ModalControl>
</template>

<script>
import ModalControl from "./../controls/ModalControl.vue";
import ButtonControl from "./../controls/ButtonControl.vue";
import mixin from "./../../mixin.js";

export default {
  name: "v-prompt",
  mixins: [mixin],
  emits: ["ok", "cancel", "closed", "update:show"],
  components: {
    ModalControl,
    ButtonControl,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    message: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      display: this.show,
    };
  },
  mounted() {
    this.display = this.show;
  },
  methods: {
    ok() {
      this.display = false;
      this.$emit("update:show", false);
      this.$emit("ok");
    },
    cancel() {
      this.display = false;
      this.$emit("update:show", false);
      this.$emit("cancel");
    },
    closed() {
      this.display = false;
      this.$emit("update:show", false);
      this.$emit("closed");
    },
  },
  watch: {
    show(n) {
      this.display = n;
    },
  },
};
</script>
